export default "__VITE_ASSET__d6f6b0ac__"